<template>
  <div class="section py-0">
    <div class="section">
      <div class="columns">
        <div class="column">
          <h2 class="title is-1">
            {{ userById(userId).salutation }} {{ userById(userId).first_name }}
            {{ userById(userId).last_name }}
          </h2>
        </div>
        <div class="column is-narrow is-flex">
          <iconRow
            :data="userById(userId).products_subscribed"
            dataClass="mr-2"
            dataSize="is-medium"
          />
          <userTag
            v-if="'type' in userById(userId)"
            :data="userById(userId).type"
            dataSize="is-medium"
          />
        </div>
      </div>
    </div>
    <div class="section pt-0">
      <div class="columns is-desktop">
        <div class="column is-half-desktop">
          <div class="is-flex is-justify-content-space-between">
            <h4 class="title is-3">Profil</h4>
            <section class="b-tooltips">
              <b-tooltip
                :label="
                  userById(userId).activated
                    ? 'Nutzer ist aktiviert'
                    : 'Nutzer ist nicht aktiviert'
                "
                position="is-top"
                style="margin-right: 20px"
              >
                <b-button style="border: 0" @click="toggleUserActivationState">
                  <b-icon
                    :type="
                      userById(userId).activated ? 'is-success' : 'is-danger'
                    "
                    icon-pack="fas"
                    icon="circle"
                    style=""
                  ></b-icon>
                </b-button>
              </b-tooltip>
              <b-tooltip
                v-if="userIdInt !== me.id"
                :label="
                  userById(userId).activated
                    ? 'Nutzer deaktivieren'
                    : 'Nutzer aktivieren'
                "
                position="is-top"
              >
                <b-button class="is-light" @click="toggleUserActivationState">
                  <b-icon
                    :icon="!userById(userId).activated ? 'check' : 'times'"
                  ></b-icon>
                </b-button>
              </b-tooltip>
              <b-tooltip
                v-if="!userById(userId).activated"
                label="Aktivierungs E-Mail erneut versenden"
                position="is-top"
              >
                <b-button class="is-light" @click="sendActivationMail">
                  <b-icon icon="envelope"></b-icon>
                </b-button>
              </b-tooltip>
              <b-tooltip
                label="Aktivierungs-Link anzeigen"
                v-if="!userById(userId).activated"
                position="is-top"
              >
                <b-button class="is-light" @click="getActivationLink">
                  <b-icon icon="link"></b-icon>
                </b-button>
              </b-tooltip>
              <b-tooltip
                label="Nutzer löschen"
                position="is-top"
                v-if="userIdInt !== me.id"
              >
                <b-button class="is-light" @click="confirmDeleteUser">
                  <b-icon icon="trash-alt"></b-icon>
                </b-button>
              </b-tooltip>
            </section>
            <!-- <b-button class="is-success" @click="activateUser">
              <b-icon icon="trash-alt"></b-icon>
            </b-button>
            <b-button class="is-light" @click="confirmDeleteUser">
              <b-icon icon="trash-alt"></b-icon>
            </b-button> -->
          </div>
          <UserSimple @submit="updateUser" :user="userById(userId)" />
        </div>
        <div class="column is-half-dekstop">
          <div class="columns">
            <div class="column set-height">
              <h4 class="title is-3">Organisation</h4>
            </div>
          </div>
          <OrgPreview :orgId="userById(userId).org_id" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import iconRow from '@/components/helper/IconRow.vue';
import userTag from '@/components/editUser/UserTag.vue';

import UserSimple from '@/components/editUser/UserSimple.vue';
import OrgPreview from '@/components/editOrg/OrgPreview.vue';

import notification from '@/functions/snackbarHandler';

export default {
  name: 'ViewUser',
  // metaInfo: {
  //   title: 'Nutzer',
  // },
  components: {
    iconRow,
    userTag,
    UserSimple,
    OrgPreview,
  },
  data() {
    return {
      active: 0,
    };
  },
  props: ['userId'],
  computed: {
    ...mapGetters({
      me: 'user/me',
      error: 'user/error',
      userById: 'user/dataById',
    }),
    userIdInt() {
      return parseInt(this.userId, 10);
    },
    userIdType() {
      return typeof this.userId;
    },
  },
  methods: {
    updateUser(user) {
      this.$store.dispatch('user/UPDATE', user);
    },
    toggleUserActivationState() {
      const user = this.userById(this.userId);
      this.$store.dispatch('user/UPDATE', { id: user.id, activated: !user.activated });
    },
    deleteUser() {
      this.$store.dispatch('user/DELETE', { id: this.userIdInt });
    },
    confirmDeleteUser() {
      this.$buefy.dialog.confirm({
        title: 'Account löschen',
        message: `Sind Sie sicher, dass Sie das Konto von ${
          this.userById(this.userId).first_name
        } ${
          this.userById(this.userId).last_name
        } <b>löschen</b> wollen? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: 'Account löschen',
        cancelText: 'Abbrechen',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteUser(this.user),
      });
    },
    sendActivationMail() {
      this.$store.dispatch('email/ACTIVATE', { id: this.userIdInt });
    },
    ActivationLinkCallback(payload) {
      this.$buefy.dialog.prompt({
        message: 'Aktivierungs-Link',
        inputAttrs: { type: 'text', value: payload.link },
        confirmText: 'In Zwischenablage kopieren',
        cancelText: 'Schließen',
        trapFocus: true,
        closeOnConfirm: false,
        onConfirm: () => this.copyToClipBoard(payload.link),
      });
      console.log('callback');
      console.log(payload);
    },
    copyToClipBoard(textToCopy) {
      const tmpTextField = document.createElement('textarea');
      tmpTextField.textContent = textToCopy;
      tmpTextField.setAttribute('style', 'position:absolute; right:200%;');
      document.body.appendChild(tmpTextField);
      tmpTextField.select();
      tmpTextField.setSelectionRange(0, 99999);
      document.execCommand('copy');
      tmpTextField.remove();
      notification.success('Link in Zwischenablage kopiert!');
    },
    getActivationLink() {
      this.$store.dispatch('user/GET_ACTIVATION_LINK', {
        payload: { id: this.userIdInt },
        callback: this.ActivationLinkCallback,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.set-height {
  height: 65px;
}
</style>
